var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atlas-flex atlas-flex-col atlas-h-[100vh] atlas-overflow-hidden"},[_c('NavbarLayout'),_c('div',{staticClass:"letter-sending atlas-justify-between atlas-flex atlas-flex-row"},[_c('Letters')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }